import { render, staticRenderFns } from "./myCustomer.vue?vue&type=template&id=92446fea"
import script from "./myCustomer.vue?vue&type=script&lang=js"
export * from "./myCustomer.vue?vue&type=script&lang=js"
import style0 from "./myCustomer.vue?vue&type=style&index=0&id=92446fea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports